export function formatNumber(number, locales = 'bs-BA', maximumFractionDigits = 2) {
    return new Intl.NumberFormat(locales, {
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: maximumFractionDigits // This ensures that we always have two decimal places
    }).format(number);
}